module.exports = __webpack_public_path__ + "img/gcba.b6ea74c2.png";